
const flags = {};

const defineFlag = (key, description, isDeprecated=false) => {
  flags[key] = {key, description, isDeprecated};
};

defineFlag('funds', 'Controls visibility of the pooled funds feature for campaigns.');
defineFlag('intl', 'Controls visibility and access to international nonprofits.');
defineFlag('every-cent', 'Controls access to the DAF Funds Overview page.');
defineFlag('cattrs', 'Controls visibility of custom attributes features.');
defineFlag('social', 'Controls visibility of social feeds.');
defineFlag('rte-md', 'Controls access to markdown toggle in rich text editor.');
defineFlag('grants', 'Controls access to grant application management system. WIP.');
defineFlag('nylas', 'Controls access to calendar integration.');

const sortedFlags = Object.values(flags).sort((a, b) => {
  if (a.isDeprecated && !b.isDeprecated) return 1;
  if (!a.isDeprecated && b.isDeprecated) return -1;
  if (a.key > b.key) return 1;
  if (a.key < b.key) return -1;
  return 0;
});

export {
  sortedFlags,
};

export default flags;
